// import Img from "../../images/competitions/breakfree.JPG";
// import beattrippers from "../../images/competitions/beattrippers.JPG";
// import campusidol from "../../images/competitions/campusidol.JPG";
// import film from "../../images/competitions/filmm.jpg";
// import standup from "../../images/competitions/standup.jpg";
// import glitz from "../../images/competitions/glitz.jpg";
// import artattack from "../../images/competitions/artattack.jpg";
// import doddles from "../../images/competitions/doodles.jpg";
// import nrytanjali from "../../images/competitions/nryt.png";
// import Picelectic from "../../images/competitions/pice.jpg";
// import Paint from "../../images/competitions/paint.png";
export const groupedcomp = [
  [
    {
      name: "Breakfree",
      reglink: "https://dare2compete.com/o/JBdSQcm?lb=KnvQoHU",
      sublink: "https://forms.gle/7o7Ur19UWNw5GhPJA",
      rules:
        "https://docs.google.com/document/d/1pzpTx8S8wuq0pDtpWWlYoeypnF06Wu0Crbqe258gRM4/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/breakfree-min_IlKW0NAMz.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1647598282700",
      details:
        "Is dancing your passion? Does the zen of dance breathe life into your torrid day? This is where you can show off your moves to the masses and shine. It is one of the biggest and most glamorous events of the fest. Participants can perform any dance form (except classical).",
    },
    {
      name: "Beat Trippers",
      reglink: "https://dare2compete.com/o/I3PEK5Z?lb=KnvQoHU",
      sublink: "https://forms.gle/BL8zB7cgYiv1d6Mk8",
      rules:
        "https://docs.google.com/document/d/1s0Xn13I8cMCrzEX4xt0Iw7C6pQTJuqUnyggpFWDZXtY/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/beattrippers-min_sFoO_ESl4.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1647598282770",
      details:
        "Coordination is what matters when it comes to a group performance. It is a group dance event where one can show off their individual talents or spellbind the crowd with their coordination. It's time to move and shake and drop it.",
    },
    {
      name: "Campus Idol",
      reglink: "https://dare2compete.com/o/jOnBytU?lb=KnvQoHU",
      sublink: "https://forms.gle/YPDJXae6UJJhJK346",
      rules:
        "https://docs.google.com/document/d/1qvKRpvBM1DU8wt_sAT3MQ6T0lPrKntDzjm4CMLL5boo/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/campusidol-min_NJvLervgN.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1647598283409",
      details:
        "When your passion is singing ,nothing can stop you from bringing your music to life.Campus Idol is the perfect platform to help you share love and happiness through your song!",
    },
  ],
  [
    {
      name: "Filmfare Fiesta",
      reglink:
        "https://dare2compete.com/creative-cultural-event/filmfare-fiesta-elan-ivision-2022-iit-hyderabad-indian-institute-of-technology-iit-hyderabad-272833",
      sublink: "https://forms.gle/brEouAmZhbjghXwQA",
      rules:
        "https://docs.google.com/document/d/1Dch9MOiJLGnyDCf63N6oTgavE4YxqxXWUjoDdGfoMQM/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/filmm-min__R-mLR83W.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598283304",
      details:
        "Short films are a catalyst for creative potential. Once again this year, ELAN & NVISION is hosting FILMFARE FIESTA to unleash the creativity in you. Make your own short film, enthrall and captivate movie buffs with your creativity. The stage at Elan & ηvision 2020 is set for you. Get judged by esteemed people in the film industry.",
    },
    {
      name: "Stand Up Comedy",
      reglink: "https://dare2compete.com/o/Un47bgp?lb=KnvQoHU",
      sublink: "https://forms.gle/8T9GwzxzdqSSu98P7",
      rules:
        "https://docs.google.com/document/d/15pHNQlm8iv4UHCrdTv4py64JB39YW2GKAc7eguKMpoo/edit?usp=sharing",
      img:"https://ik.imagekit.io/lc4zhdkrtsr/competition/standup-min_fLT51IZNN.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598286477",
      details:
        "The advent of social media and online pop culture has brought about a radical change in the Indian comedy circles as well. The past decade saw the rise of stand up comedians and now it’s your turn. Can you enthrall the audience with your wacky humor? Can you brighten up someone’s day? This is the event where you can test your skills against other similarly talented folk and try to come out on top.",
    },
    {
      name: "Glitz & Glamour",
      reglink:
        "https://dare2compete.com/creative-cultural-event/glitz-glamour-elan-ivision-2022-iit-hyderabad-272835",
      sublink: "https://forms.gle/YyZAgE2VRCGzUTrE8",
      rules:
        "https://docs.google.com/document/d/1vYz61w_uMz9aE5rKKIlocSPe5Vx1hQiAHB_nt9N__Us/edit?usp=sharing",
      img:"https://ik.imagekit.io/lc4zhdkrtsr/competition/glitz-min_PQBAXiEoC.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598283824",
      details:
        "Modelling is not just about beauty, it is about the way you portray yourself with confidence and glamour yet keeping simplicity in you alive! A platform  for all those young ladies out there who always dreamt of being a model. Elan & ηvision 2022 gives you the opportunity to take the first step towards your passion.",
    },
  ],
  [
    {
      name: "Paint the Screen",
      reglink: "https://dare2compete.com/o/2Lvyc1o?lb=KnvQoHU",
      sublink: "https://forms.gle/9FoS6Bg5kiUt54nE7",
      rules:
        "https://docs.google.com/document/d/1aMF6wAu0zRFrOK-0Kpq4YCBxlDSCMtLh1Ai7YgD6nCc/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/paint-min_yeOataR1t.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285082",
      details:
        "Today the world  is all about digitalization.So,Elan and nvision presents you with an amazing opportunity to put all your imagination without any bound  to digitize your art and get along.",
    },
    {
      name: "Art attack",
      reglink:
        "https://dare2compete.com/creative-cultural-event/art-attack-elan-ivision-2022-iit-hyderabad-272827",
      sublink: "https://forms.gle/fyyrHb4E9MQh5Rmf6",
      rules:
        "https://docs.google.com/document/d/1sS_LvZlWaBZaksMOs1eYgIMZaLhlWhKVyC6ivmZlUxM/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/artattack-min_3ypzZpfUO.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598281434",
      details:
        "Painting is not about what one sees but what one can make others see! This theme-based painting competition is an opportunity to bring your imagination and creativity together on the paper alive.",
    },
    {
      name: "Doddle Creation",
      reglink:
        "https://dare2compete.com/creative-cultural-event/doodle-art-elan-ivision-2022-iit-hyderabad-272832",
      sublink: "https://forms.gle/ZBTCqW9Vh442ifGfA",
      rules:
        "https://docs.google.com/document/d/1rwGaRbJFfMMR2qOVrPWwdM72eAcNzH8ur_Jv-YTgYIY/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/doodles-min_HkkhxfVdS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598282756",
      details:
        "Doodling is a fun way of expressing yourself! It is not just a stress buster but also unlocks the subconscious creativity within you. In these times of pandemic , the elan & nvision is here to your rescue with its very own doodle art competition! Get ready to show off your doodles !",
    },
  ],
  [
    {
      name: "Nrityanjali",
      reglink: "https://dare2compete.com/o/5wkyMb7?lb=KnvQoHU",
      sublink: "https://forms.gle/bMcrbbZ2MWc4xrE9A",
      rules:
        "https://docs.google.com/document/d/1b1Xx39x8NFiNhCHjGkPtyNqCubpALzxyWd3ud3ZfHaU/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/nryt-min_1lofqgQvw.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285086",
      details:
        "Classical dance is the fusion of the mind's emotions and the body's articulate movements. It takes the viewers to a completely different world of calmness and imagination. We, at elan invite you to celebrate the beauty of Indian classical dance. Come and mesmerize the audience with your grace, expressions and soulful talent!",
    },
    {
      name: "Picelectic",
      reglink: "https://dare2compete.com/o/s8GEaNl?lb=KnvQoHU",
      sublink: "https://forms.gle/1CFEgse2faZkDjVF8",
      rules:
        "https://docs.google.com/document/d/17W9bejet1uF_NHQQ_66PxkohBfuCS-7AyqpC5su6iFs/edit?usp=sharing",
      img: "https://ik.imagekit.io/lc4zhdkrtsr/competition/pice-min_WkQ8MXNbv.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1647598285576",
      details:
        "A photograph is the pause button of life. Photography is the best way to capture a moment and save it forever! It is an austere and blazing poetry of the real. So, keep your camera ready to capture the perfect moment and show us your talent!",
    },
  ],
];
